var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase, ReactElementFactory, Scroll } from "survey-react-ui";
import { TabButtonComponent } from "./TabButton";
var TabControl = /** @class */ (function (_super) {
    __extends(TabControl, _super);
    function TabControl(props) {
        return _super.call(this, props) || this;
    }
    TabControl.prototype.getStateElement = function () {
        return this.props.model;
    };
    TabControl.prototype.canRender = function () {
        if (!this.props.model)
            return false;
        return _super.prototype.canRender.call(this);
    };
    TabControl.prototype.renderElement = function () {
        return (React.createElement("div", { className: this.props.model.sideBarClassName },
            React.createElement("div", { className: "svc-sidebar-tabs__top-container" },
                React.createElement("div", { className: "svc-sidebar-tabs__collapse-button" },
                    React.createElement(TabButtonComponent, { model: this.props.model.expandCollapseAction })),
                React.createElement("div", { className: "svc-sidebar-tabs__separator" },
                    React.createElement("div", null)),
                React.createElement(Scroll, null,
                    React.createElement("div", { className: "svc-sidebar-tabs__items" },
                        React.createElement(TabsComponent, { model: this.props.model.topToolbar })))),
            React.createElement("div", { className: "svc-sidebar-tabs__bottom-container" },
                React.createElement("div", { className: "svc-sidebar-tabs__items" },
                    React.createElement(TabsComponent, { model: this.props.model.bottomToolbar })))));
    };
    return TabControl;
}(SurveyElementBase));
ReactElementFactory.Instance.registerElement("svc-tab-control", function (props) {
    return React.createElement(TabControl, props);
});
var TabsComponent = /** @class */ (function (_super) {
    __extends(TabsComponent, _super);
    function TabsComponent(props) {
        return _super.call(this, props) || this;
    }
    TabsComponent.prototype.getStateElement = function () {
        return this.props.model;
    };
    TabsComponent.prototype.renderElement = function () {
        return React.createElement(React.Fragment, null, this.props.model.actions.map(function (item, itemIndex) { return React.createElement(TabButtonComponent, { model: item, key: "item" + itemIndex }); }));
    };
    return TabsComponent;
}(SurveyElementBase));
